"use client";

import Link from "next/link";
import {
  InstagramIcon,
  LinkedInIcon,
  TwitterIcon,
} from "@/components/icons/SocialIcons";
import type { FooterSocialConfig } from "@/lib/config/services.config";

interface FooterSocialProps {
  social: FooterSocialConfig;
}

export default function FooterSocial({ social }: FooterSocialProps) {
  return (
    <div>
      <h3 className="mb-6 text-sm font-medium text-dark dark:text-white">
        Connect
      </h3>

      <div className="mb-8">
        <a
          href={social.primary.href}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-3 rounded-full bg-surface-dark/5 px-4 py-2 transition-all duration-300 hover:bg-dark/10 hover:pl-6 hover:pr-8 dark:bg-surface-light/5 dark:hover:bg-white/10"
        >
          <span className="transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-12">
            <LinkedInIcon />
          </span>
          <span className="transform transition-transform duration-300 group-hover:translate-x-1">
            {social.primary.label}
          </span>
        </a>
        <p className="mt-2 text-sm text-gray-default transition-colors duration-300 group-hover:text-current dark:text-gray-light">
          {social.primary.description}
        </p>
      </div>

      <div className="mb-8">
        <Link
          href="/newsletter"
          className="group inline-flex items-center gap-3 rounded-full bg-surface-dark/5 px-4 py-2 transition-all duration-300 hover:bg-dark/10 hover:pl-6 hover:pr-8 dark:bg-surface-light/5 dark:hover:bg-white/10"
        >
          <span className="transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-12">
            <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
              <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
            </svg>
          </span>
          <span className="transform transition-transform duration-300 group-hover:translate-x-1">
            Newsletter
          </span>
        </Link>
        <p className="mt-2 text-sm text-gray-default transition-colors duration-300 group-hover:text-current dark:text-gray-light">
          Follow our latest experiments
        </p>
      </div>

      <div className="space-y-3">
        <div className="flex items-center gap-4">
          <a
            href={social.others[0].href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Township on ${social.others[0].label}`}
            className="group text-gray-800 transition-all duration-300 hover:text-gray-950 dark:text-gray-200 dark:hover:text-white"
          >
            <span
              className="transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-12"
              aria-hidden
            >
              <InstagramIcon />
            </span>
          </a>
          <a
            href={social.others[1].href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Township on ${social.others[1].label}`}
            className="group text-gray-800 transition-all duration-300 hover:text-gray-950 dark:text-gray-200 dark:hover:text-white"
          >
            <span
              className="transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-12"
              aria-hidden
            >
              <TwitterIcon />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}
